/**
 * このゲームの識別子。**Phaser を引かない軽いモジュール**にしておく
 * （`registry.ts` と `platform/` から参照されるので、ここが重いと初期バンドルが太る）。
 *
 * 🔴 **この文字列は後から変更できない**。D1 の `game_key` / `src/games/<key>/` /
 *   `src/locales/<lang>/<key>.json` / `public/assets/<key>/` / localStorage の `<key>.*`
 *   が全部これと同じでなければならない（CLAUDE.md の規則1）。
 *
 * 名前はロゴ（`Mahjong Solitaire` / 麻雀ソリティア）に合わせた。
 * ⚠️ **`nikakudori` と紛らわしくないか**を検討した上での `mahjong` である。
 *   どちらも麻雀牌を使うが、二角取りは「経路探索」、こちらは「積み上げた山から取る」で
 *   ジャンルが別。表示名も別（二角取り Solitaire / 麻雀ソリティア）なので、
 *   利用者から見て衝突しない。
 */
export const GAME_KEY = 'mahjong';
